import React, { Component } from "react";


class SideBySideView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src2tgt: this.get_src2tgt(this.props.alignment),
            tgt2src: this.get_tgt2src(this.props.alignment),
            src_highlight: [],
            tgt_highlight: [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.alignment!==prevProps.alignment){
            this.setState({
                src2tgt: this.get_src2tgt(this.props.alignment),
                tgt2src: this.get_tgt2src(this.props.alignment),
            })
        }
    }

    get_src2tgt = (arr)=>{
        let ret_arr = {}
        arr.map(element=>{
            if(element[0] in ret_arr){
                ret_arr[element[0]].push(element[1])
            }else{
                ret_arr[element[0]] = [element[1]]
            }
        })
        return ret_arr
    }

    get_tgt2src = (arr)=>{
        let ret_arr = {}
        arr.map(element=>{
            if(element[1] in ret_arr){
                ret_arr[element[1]].push(element[0])
            }else{
                ret_arr[element[1]] = [element[0]]
            }
        })
        return ret_arr
    }

    set_src_highlight= (id)=>{
        const {src2tgt, tgt2src} = this.state
        if(id in src2tgt){
            // console.log(id, src2tgt[id])
            let src_highlight = [id]
            let tgt_highlight = src2tgt[id]
            src2tgt[id].map(element=>{
                tgt2src[element].map(el=>{
                    if(!src_highlight.includes(el)){
                        src_highlight.push(el)
                    }
                })
            })
            this.setState({
                src_highlight: src_highlight,
                tgt_highlight: tgt_highlight
            })
        }
    }


    set_tgt_highlight= (id)=>{
        const {src2tgt, tgt2src} = this.state
        if(id in tgt2src){
            // console.log(id, tgt2src[id])
            let src_highlight = tgt2src[id]
            let tgt_highlight = [id]
            tgt2src[id].map(element=>{
                src2tgt[element].map(el=>{
                    if(!tgt_highlight.includes(el)){
                        tgt_highlight.push(el)
                    }
                })
            })
            this.setState({
                src_highlight: src_highlight,
                tgt_highlight: tgt_highlight
            })
        }
    }

    reset_highlight= ()=>{
            this.setState({
                src_highlight: [],
                tgt_highlight: []
            })
    }

    render(){
        const {src, tgt, alignment, idx, model_name, colors, search_term, search_term_language} = this.props;
        const {src2tgt, tgt2src, src_highlight, tgt_highlight} = this.state
        const default_css = " p-1 "
        const highlight_css = default_css + " bg-neutral-700 text-yellow-500 rounded px-1"
        const unaligned_css = default_css + alignment.length===0?" text-gray-600":" text-red-600"
        return <div className="w-full text-xs my-10">
                    <div className="flex">
                        <div className="w-1/2 leading-loose  text-left px-4 border-r">{src.map((token, id) =>{
                            let underline = search_term_language==="src" && search_term===token?" border-b-4 border-neutral-600 ": ""
                            return <span key={"src_"+idx+"_"+id}
                                         className={underline + (id in src2tgt?(src_highlight.includes(id)?highlight_css:default_css):unaligned_css)}
                                         id={"src_"+idx+"_"+id}
                                         onMouseOver={()=>{this.set_src_highlight(id)}}
                                         onMouseOut={()=>{this.reset_highlight()}}
                            > {token} </span>})}
                        </div>

                        <div className="w-1/2 leading-loose px-4 border-l text-left">{tgt.map((token, id) =>{
                            let underline = search_term_language==="tgt" && search_term===token?" border-b-4 border-neutral-600 ": ""

                            return <span key={"tgt_"+idx+"_"+id}
                                         id={"tgt_"+idx+"_"+id}
                                         className={underline + (id in tgt2src?(tgt_highlight.includes(id)?highlight_css:default_css):unaligned_css)}
                                         onMouseOver={()=>{this.set_tgt_highlight(id)}}
                                         onMouseOut={()=>{this.reset_highlight()}}
                            > {token} </span>})}
                        </div>
                    </div>
            {model_name!==null?
                    <div className="mt-4">


                            <span className="italic text-gray-500">This alignment created by</span>
                            <span className="text-xs px-2 py-1 m-1 rounded text-white"
                                      style={{"backgroundColor": colors[model_name], "fontSize": "9px"}}>{model_name}</span>
                        <span className="italic text-gray-500">. Use the barchart to switch between models.</span>

                    </div>:null}

        </div>
    }
}

export default SideBySideView;